import React, { useState, useRef, useEffect } from 'react';

const SelectSearch = ({ options = [], placeholder = 'Select...', value, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const dropdownRef = useRef(null);

  const filteredOptions = options.filter(option =>
    option.label.toLowerCase().includes(searchTerm.toLowerCase())
  );

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
        setSearchTerm('');
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSelect = (option) => {
    onChange(option);
    setIsOpen(false);
    setSearchTerm('');
  };

  const displayValue = value ? value.label : placeholder;

  return (
    <div className="Spassov_container">
      <div className="Spassov_dropdown" ref={dropdownRef}>
        <button
          type="button"
          className="Spassov_dropdown_trigger"
          onClick={() => setIsOpen(!isOpen)}
        >
          <span className={`Spassov_dropdown_text ${!value ? 'Spassov_placeholder' : ''}`}>
            {displayValue}
          </span>
          <svg
            className={`Spassov_dropdown_icon ${isOpen ? 'Spassov_dropdown_icon_open' : ''}`}
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
          >
            <path
              d="M5 7.5L10 12.5L15 7.5"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>

        {isOpen && (
          <div className="Spassov_dropdown_menu">
            <div className="Spassov_search_container">
              <input
                type="text"
                className="Spassov_search_input"
                placeholder="Search..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                autoFocus
              />
            </div>

            <div className="Spassov_options_list">
              {filteredOptions.map((option, index) => (
                <div
                  key={option.value || index}
                  className={`Spassov_option ${value?.value === option.value ? 'Spassov_option_selected' : ''}`}
                  onClick={() => handleSelect(option)}
                >
                  {option.label}
                </div>
              ))}
              {filteredOptions.length === 0 && (
                <div className="Spassov_no_results">No results found</div>
              )}
            </div>
          </div>
        )}
      </div>

      <style jsx>{`
        .Spassov_container {
          width: 100%;
        }

        .Spassov_dropdown {
          position: relative;
          width: 100%;
        }

        .Spassov_dropdown_trigger {
          width: 100%;
          padding: 10px 12px;
          background: white;
          border: 1px solid #d1d5db;
          border-radius: 6px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          cursor: pointer;
          font-size: 14px;
          color: #374151;
          transition: all 0.2s;
          text-align: left;
        }

        .Spassov_dropdown_trigger:hover {
          border-color: #9ca3af;
        }

        .Spassov_dropdown_trigger:focus {
          outline: none;
          border-color: #3b82f6;
          box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
        }

        .Spassov_dropdown_text {
          flex: 1;
          text-align: left;
        }

        .Spassov_placeholder {
          color: #9ca3af;
        }

        .Spassov_dropdown_icon {
          width: 20px;
          height: 20px;
          color: #9ca3af;
          transition: transform 0.2s;
          flex-shrink: 0;
        }

        .Spassov_dropdown_icon_open {
          transform: rotate(180deg);
        }

        .Spassov_dropdown_menu {
          position: absolute;
          top: calc(100% + 4px);
          left: 0;
          right: 0;
          background: white;
          border: 1px solid #e5e7eb;
          border-radius: 6px;
          box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
          z-index: 1000;
          overflow: hidden;
        }

        .Spassov_search_container {
          padding: 8px;
          border-bottom: 1px solid #e5e7eb;
        }

        .Spassov_search_input {
          width: 100%;
          padding: 8px 12px;
          border: 1px solid #d1d5db;
          border-radius: 4px;
          font-size: 14px;
          outline: none;
          transition: border-color 0.2s;
        }

        .Spassov_search_input:focus {
          border-color: #3b82f6;
        }

        .Spassov_options_list {
          max-height: 160px;
          overflow-y: auto;
        }

        .Spassov_option {
          padding: 10px 12px;
          cursor: pointer;
          font-size: 14px;
          color: #374151;
          transition: background-color 0.15s;
        }

        .Spassov_option:hover {
          background-color: #f3f4f6;
        }

        .Spassov_option_selected {
          background-color: #eff6ff;
          color: #3b82f6;
        }

        .Spassov_option:active {
          background-color: #e5e7eb;
        }

        .Spassov_no_results {
          padding: 16px;
          text-align: center;
          color: #9ca3af;
          font-size: 14px;
        }

        .Spassov_options_list::-webkit-scrollbar {
          width: 6px;
        }

        .Spassov_options_list::-webkit-scrollbar-track {
          background: #f9fafb;
        }

        .Spassov_options_list::-webkit-scrollbar-thumb {
          background: #d1d5db;
          border-radius: 3px;
        }

        .Spassov_options_list::-webkit-scrollbar-thumb:hover {
          background: #9ca3af;
        }
      `}</style>
    </div>
  );
};

export default SelectSearch;